import * as R from 'ramda'

export default (billsByPropertyID) => {
	let expenses = R.map((propertyBills) => {
		let billsByCategory = R.pipe(R.map(x => x.expenses), R.reduce((acc, item) => acc.concat(item), []), R.groupBy(x => x.category.split(":")[1].split(" ")[1]))(propertyBills)
		let categories = R.map(categoryBills => {
			return R.reduce((sum, next) => sum + +next.amount, 0)(categoryBills)
		})(billsByCategory)
		let total = R.pipe(R.values, R.reduce(R.add, 0))(categories)
		return {categories, total}
	})(billsByPropertyID)

	let total = R.pipe(R.values, R.reduce((total, stats) => R.mergeWith(R.add, total, stats.categories), {}))(expenses)
	let sortExpenses = R.pipe(R.mapObjIndexed((amount, category) => ({amount, category})), R.values, R.sortBy(R.prop('category')))
	expenses = {
		...R.map((stats) => ({
			...stats
		  , categories: sortExpenses(stats.categories)
		}))(expenses)
	  , total: {
			categories: sortExpenses(total)
		  , total: R.pipe(R.values, R.reduce(R.add, 0))(total)
		}
	}

	return expenses
}



// WEBPACK FOOTER //
// ./src/helpers/kpi/expenses.js